// extracted by mini-css-extract-plugin
module.exports = {"login":"auth_login__3szSH","login__top-background":"auth_login__top-background__Ty90o","login__card-is-centered":"auth_login__card-is-centered__2OBmq"};